import { toastError, toastSuccess, toastWarning } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import * as actionTypes from '@store/design/action-types';
import { fetchTotalLikeCount } from '@store/favourite/actions';

import { fetchLatestMeasurementTypeInfo } from '@services/measurementService';

import ApiClient from '@lib/apiClient';

import { getUserPreference, printApiError } from '@utils/Util';

import { decrementLikeCountByOne, incrementLikeCountByOne } from '@/features/favourites/redux/favouriteSlice';

export const getCollections =
	(term = '') =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_COLLECTION_REQUEST });
			let params = `?name=${encodeURIComponent(term)}&canAddProduct=${true}`;
			const response = await ApiClient.GET('getCollectionList', params);
			dispatch({
				type: actionTypes.FETCH_COLLECTION_SUCCESS,
				payload: response.data.data
			});
		} catch {
			dispatch({ type: actionTypes.FETCH_COLLECTION_FAILURE });
		}
	};

export const getBrands =
	(params = '?page=0&size=1000') =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_BRAND_REQUEST });
			const response = await ApiClient.GET('getBrandList', params);
			dispatch({
				type: actionTypes.FETCH_BRAND_SUCCESS,
				payload: response.data.data
			});
		} catch {
			dispatch({ type: actionTypes.FETCH_BRAND_FAILURE });
		}
	};

export const getMarkets = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_MARKET_REQUEST });
		const response = await ApiClient.GET('getMarket');
		dispatch({
			type: actionTypes.FETCH_MARKET_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_MARKET_FAILURE });
	}
};

export const getCategories = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_CATEGORY_REQUEST });
		const response = await ApiClient.GET('getDesignCategories');
		dispatch({
			type: actionTypes.FETCH_CATEGORY_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_CATEGORY_FAILURE });
	}
};

export const getSubCategories = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SUB_CATEGORY_REQUEST });
		const response = await ApiClient.GET('getDesignSubCategories');
		dispatch({
			type: actionTypes.FETCH_SUB_CATEGORY_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_SUB_CATEGORY_FAILURE });
	}
};

export const getSeasons = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_SEASONS_REQUEST });
		const response = await ApiClient.GET('getAllSeasons');
		dispatch({
			type: actionTypes.FETCH_SEASONS_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_SEASONS_FAILURE });
	}
};

export const getFabricTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_FABRIC_TYPE_REQUEST });
		const response = await ApiClient.GET('getFabricTypes');
		dispatch({
			type: actionTypes.FETCH_FABRIC_TYPE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_FABRIC_TYPE_FAILURE });
	}
};

export const getFabrics = (fabricType) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_FABRIC_REQUEST });
		let params = `?fabricType=${fabricType}`;
		const response = await ApiClient.GET('getAllFabrics', params);
		dispatch({
			type: actionTypes.FETCH_FABRIC_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_FABRIC_FAILURE });
	}
};

export const getColors =
	(term = '', size = 20) =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_COLOR_REQUEST });
			let params = `?page=0&size=${size}&search=${term}`;
			const response = await ApiClient.GET('getAllColors', params);
			dispatch({
				type: actionTypes.FETCH_COLOR_SUCCESS,
				payload: response.data
			});
		} catch {
			dispatch({ type: actionTypes.FETCH_COLOR_FAILURE });
		}
	};

export const getGroupColors = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_COLOR_GROUP_REQUEST });
		const response = await ApiClient.GET('getAllColorGroup');
		dispatch({
			type: actionTypes.FETCH_COLOR_GROUP_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_COLOR_GROUP_FAILURE });
	}
};

export const getFabricPatterns = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_FABRIC_PATTERN_REQUEST });
		const response = await ApiClient.GET('getAllFabricPatterns');
		dispatch({
			type: actionTypes.FETCH_FABRIC_PATTERN_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_FABRIC_PATTERN_FAILURE });
	}
};

export const getFabricComposition = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_FABRIC_COMPOSITION_REQUEST });
		const response = await ApiClient.GET('getAllComposition');
		dispatch({
			type: actionTypes.FETCH_FABRIC_COMPOSITION_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_FABRIC_COMPOSITION_FAILURE });
	}
};

export const getDesignDetailsInfo = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_DESIGN_DETAILS_REQUEST });
		const response = await ApiClient.GET('getDesignDetails', id);
		dispatch({
			type: actionTypes.FETCH_DESIGN_DETAILS_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_DESIGN_DETAILS_FAILURE });
	}
};

export const fetchDocResponse = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_DOC_RESPONSE_REQUEST });
		const response = await ApiClient.GET('getDocumentResponse', id);
		dispatch({
			type: actionTypes.FETCH_DOC_RESPONSE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_DOC_RESPONSE_FAILURE });
	}
};

export const fetchMaterials = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_MARKET_REQUEST });
		const response = await ApiClient.GET('getAllMaterials');
		dispatch({
			type: actionTypes.FETCH_MATERIAL_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_MATERIAL_FAILURE });
	}
};

export const fetchProductMaterials = (id, setIsShowMaterial) => async (dispatch) => {
	try {
		dispatch(openLoader());
		dispatch({ type: actionTypes.FETCH_PRODUCT_MATERIALS_REQUEST });
		const response = await ApiClient.GET('getProductMaterials', id);
		if (setIsShowMaterial) {
			setIsShowMaterial(!response.data.length > 0);
		}
		dispatch({
			type: actionTypes.FETCH_PRODUCT_MATERIALS_SUCCESS,
			payload: response.data
		});
		dispatch(closeLoader());
	} catch {
		dispatch(closeLoader());
		dispatch({ type: actionTypes.FETCH_PRODUCT_MATERIALS_FAILURE });
	}
};

export const fetchTrims = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_TRIMS_REQUEST });
		const response = await ApiClient.GET('getAllTrims');
		dispatch({
			type: actionTypes.FETCH_TRIMS_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_TRIMS_FAILURE });
	}
};

export const fetchTrimTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_TRIMS_TYPE_REQUEST });
		const response = await ApiClient.GET('getTrimsType');
		dispatch({
			type: actionTypes.FETCH_TRIMS_TYPE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_TRIMS_TYPE_FAILURE });
	}
};

export const fetchProductMeasurement =
	(id, unitType, sourcePage = 'MEASUREMENT') =>
	async (dispatch) => {
		try {
			dispatch({ type: actionTypes.FETCH_PRODUCT_MEASUREMENT_REQUEST });
			let params = `?unit=${unitType}`;
			const response = await fetchLatestMeasurementTypeInfo(id, params);
			if (sourcePage === 'MEASUREMENT') {
				dispatch({
					type: actionTypes.FETCH_PRODUCT_MEASUREMENT_SUCCESS,
					payload: response.data
				});
			} else {
				dispatch({
					type: actionTypes.FETCH_PRODUCT_MEASUREMENT_SUCCESS_DESIGN_TECHPACK,
					payload: response.data
				});
			}
		} catch {
			dispatch({ type: actionTypes.FETCH_PRODUCT_MEASUREMENT_FAILURE });
		}
	};

export const fetchAllTemplate = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_ALL_TEMPLATE_REQUEST });
		const response = await ApiClient.GET('getAllTemplate');
		dispatch({
			type: actionTypes.FETCH_ALL_TEMPLATE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_ALL_TEMPLATE_FAILURE });
	}
};

export const fetchBrandingCategory = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_BRANDING_CATEGORY_REQUEST });
		const response = await ApiClient.GET('getBrandingCategories');
		dispatch({
			type: actionTypes.FETCH_BRANDING_CATEGORY_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_BRANDING_CATEGORY_FAILURE });
	}
};

export const fetchBrandingTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_BRANDING_TYPE_REQUEST });
		const response = await ApiClient.GET('getBrandingTypes');
		dispatch({
			type: actionTypes.FETCH_BRANDING_TYPE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_BRANDING_TYPE_FAILURE });
	}
};

export const fetchInitialCosting = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_INITIAL_COSTING_REQUEST });
		const response = await ApiClient.GET('getCosting', id);
		dispatch({
			type: actionTypes.FETCH_INITIAL_COSTING_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_INITIAL_COSTING_FAILURE });
	}
};

export const fetchQuantityWiseCosting = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_QUANTITY_WISE_REQUEST });
		const response = await ApiClient.GET('getQuantityWiseCosting', id);
		dispatch({
			type: actionTypes.FETCH_QUANTITY_WISE_SUCCESS,
			payload: response.data
		});
	} catch {
		dispatch({ type: actionTypes.FETCH_QUANTITY_WISE_FAILURE });
	}
};

export const fetchProductSteps = (id) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_PRODUCT_STEPS_REQUEST });
		const response = await ApiClient.GET('getProductStepList', id);
		dispatch({
			type: actionTypes.FETCH_PRODUCT_STEPS_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_PRODUCT_STEPS_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchEnumFilter = (type) => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_ENUM_FILTER_REQUEST });
		const response = await ApiClient.GET('getEnums', type);
		dispatch({
			type: actionTypes.FETCH_ENUM_FILTER_SUCCESS,
			payload: { type: type, data: response.data }
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_ENUM_FILTER_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchEmbellishmentSubCategory = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_REQUEST });
		const response = await ApiClient.GET('getEmbellishmentSubCategory');
		dispatch({
			type: actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_EMBELLISHMENT_SUB_CATEGORY_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchTrimsSubTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_TRIMS_SUB_CATEGORY_REQUEST });
		const response = await ApiClient.GET('getTrimsSubType');
		dispatch({
			type: actionTypes.FETCH_TRIMS_SUB_CATEGORY_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_TRIMS_SUB_CATEGORY_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchLabelPackSubTypes = () => async (dispatch) => {
	try {
		dispatch({ type: actionTypes.FETCH_LABEL_PACK_SUB_TYPE_REQUEST });
		const response = await ApiClient.GET('getLabelPackSubTypes');
		dispatch({
			type: actionTypes.FETCH_LABEL_PACK_SUB_TYPE_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_LABEL_PACK_SUB_TYPE_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const upDateDesignDetails = (body, productId) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('updateGroupDocument', { ...body }, body.id);
		dispatch({ type: actionTypes.UPDATE_DESIGN_SUCCESS, payload: response.data });
		if (response.status === 200) {
			if (productId) {
				dispatch(fetchDocResponse(productId));
			}
			toastSuccess('Updated successfully');
		}
		return response.data;
	} catch (error) {
		dispatch({ type: actionTypes.UPDATE_DESIGN_FAILURE });
		if (error?.response.message) {
			toastError(error.response.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const fetchSizeForProducts = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.GET('getAvailableSizeForProduct', id);
		dispatch({
			type: actionTypes.FETCH_SIZE_FOR_PRODUCT_SUCCESS,
			payload: response.data
		});
	} catch (error) {
		dispatch({ type: actionTypes.FETCH_SIZE_FOR_PRODUCT_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const likeProduct =
	(productId, onSuccess, viewType = '', folderId = '') =>
	async (dispatch) => {
		try {
			const userPreference = getUserPreference();
			const defaultFolderId = folderId ? folderId : userPreference?.DEFAULT_FAVOURITE_FOLDER?.id || -1;
			const query = `?productIds=${productId}&responseType=${viewType}&folderId=${defaultFolderId}`;
			const response = await ApiClient.POST('likeProduct', {}, query);
			dispatch({
				type: actionTypes.LIKE_DESIGN_SUCCESS
			});
			if (onSuccess) onSuccess(response?.data);
			dispatch({
				type: 'TOTAL_LIKED_PRODUCT_SUCCESS',
				payload: response.data.payload
			});
			// dispatch(fetchTotalLikeCount());
			if (response.status === 200) {
				dispatch(incrementLikeCountByOne());
				return response.data.success;
			}
		} catch (error) {
			if (error.response?.status === 400) {
				toastWarning(error.response?.data?.message);
			} else {
				printApiError(error);
			}
			dispatch({ type: actionTypes.LIKE_DESIGN_FAILURE });
		}
	};

export const unlikeProduct = (id) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('unlikeProduct', {}, id);
		dispatch({
			type: actionTypes.UNLIKE_DESIGN_SUCCESS
		});
		dispatch({
			type: 'TOTAL_LIKED_PRODUCT_SUCCESS',
			payload: response.data.payload
		});
		// dispatch(fetchTotalLikeCount());
		if (response.status === 200) {
			dispatch(decrementLikeCountByOne());
			return response.data.success;
		}
	} catch (error) {
		dispatch({ type: actionTypes.UNLIKE_DESIGN_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};

export const removeDesignAfterMove = (data) => async (dispatch) => {
	dispatch({
		type: 'REMOVE_DESIGN_AFTER_MOVE',
		payload: data
	});
};

export const storeCollectionProducts = (data) => (dispatch) => {
	dispatch({
		type: 'STORE_COLLECTION_PRODUCTS',
		payload: data
	});
};

export const unlikeAllProduct = (param) => async (dispatch) => {
	try {
		const response = await ApiClient.POST('unlikeAllProduct', {}, param);
		dispatch({
			type: actionTypes.UNLIKE_DESIGN_SUCCESS
		});
		dispatch(fetchTotalLikeCount());
		if (response.status === 200) {
			return response.data.success;
		}
	} catch (error) {
		dispatch({ type: actionTypes.UNLIKE_DESIGN_FAILURE });
		if (error.message) {
			toastError(error.message);
		} else {
			toastError('Something went wrong! Please try again.');
		}
	}
};
